<script setup>

import { ref, computed, inject, watch } from 'vue';
import { 
	apiModifierConstante,
	apiSupprimerConstantes } from '@/services/ServiceModele.js';
import SelecteurTypeDonnee from '@/components/generiques/SelecteurTypeDonnee.vue';

const { constante } = defineProps({
  constante: Object
});

const appelerApiModifModele = inject('appelerApiModifModele');
const getTypeDonnee = inject('getTypeDonnee');
const afficherBarreFlottante = inject('afficherBarreFlottante');

const texteNom = ref(constante.nom);
const selectionTypeDonnee = ref(getTypeDonnee(constante.typeDonnee));
const valeur = ref(constante.valeur);
const boutonMenu = ref(null);

const constanteModifiee = computed(() => {
	return {
		id: constante.id,
		nom: texteNom.value,
		typeDonnee : selectionTypeDonnee.value,
		valeur: valeur.value
	};
});

watch(() => constante, (cte) => {
	texteNom.value = cte?.nom;
	selectionTypeDonnee.value = getTypeDonnee(cte?.typeDonnee);
	valeur.value = cte?.valeur;
});

watch(() => constante?.nom, (nom) => {
	texteNom.value = nom;
});

watch(() => constante?.typeDonnee, (typeDonnee) => {
	selectionTypeDonnee.value = getTypeDonnee(typeDonnee);
});

watch(() => constante.valeur, (val) => {
	valeur.value = val;
});

const itemsMenu = [
	{
		libelle: 'Supprimer',
		icones: ['fa fa-trash'],
		style: 'color: var(--couleur-supprimer); ',
		commande: () => {
			supprimer();
		}
	}
];

function reinitialiserValeurs() {
	texteNom.value = constante.nom;
	selectionTypeDonnee.value = getTypeDonnee(constante.typeDonnee);
	valeur.value = constante.valeur;
}

function basculerAffichageMenu() {
    afficherBarreFlottante({
        items: itemsMenu, 
        selectionItems: [],
        composantParent: boutonMenu.value
    });
}

function modifierConstante() {
	appelerApiModifModele(apiModifierConstante, constanteModifiee.value);
}

function supprimer() {
	appelerApiModifModele(apiSupprimerConstantes, [constante]);
}

</script>

<template>
	<div>
		<div class="detail-constante">
			<label class="intitule">Nom :</label>
			<div class="zone-nom">
				<input type="text" spellcheck="false" class="saisie-nom" 
					v-model="texteNom" 
					@keyup.enter="modifierConstante"
					@blur="reinitialiserValeurs" />
				<button class="bouton fa-solid fa-caret-down" 
					ref="boutonMenu"
					@click.stop="basculerAffichageMenu" />
			</div>
			<label class="intitule">Type :</label>
			<SelecteurTypeDonnee 
				v-model:typeDonnee="selectionTypeDonnee" 
				:proposer-types-objets="false" 
				:desactive="false" 
				@modification="modifierConstante"
				@blur="reinitialiserValeurs" />
			<label class="intitule">Valeur :</label>
			<input type="text" 
				v-model="valeur" 
				spellcheck="false" 
				@keyup.enter="modifierConstante"
				@blur="reinitialiserValeurs" />
		</div>
	</div>
</template>

<style scoped>

.entete {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 20px;
	margin-bottom: 2px;
}

.detail-constante {
	display: grid;
	grid-template-columns: auto minmax(0, 1fr);
	gap: 2px;
	margin-top: 10px;
	margin-bottom: 20px;
	padding-left: 5px;
	align-items: start;
}

.zone-nom {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.saisie-nom {
	margin-right: 2px;
	flex-grow: 1;
	min-width: 20px;
}

</style>